import {
  getIsAuthenticated,
  getCurrentLanguage,
} from 'ha/modules/AuthLogic/selectors';
import HttpStatus from 'ha/constants/HttpStatus';
import formatHrefURL from 'ha/utils/formatHrefURL';

const onEnterListYourPlace =
  store =>
  ({ location }, replace) => {
    if (!getIsAuthenticated(store.getState())) {
      const lang = getCurrentLanguage(store.getState());
      const pathname = formatHrefURL('/register', lang);

      replace({
        ...location,
        pathname,
        query: {
          /* eslint-disable-next-line camelcase */
          return_url: `${location.pathname}${location.search}`,
        },
        state: {
          redirectCode: HttpStatus.FOUND_REDIRECTION,
        },
      });
    }
  };

export default onEnterListYourPlace;
